import { forwardRef, TextareaHTMLAttributes } from 'react';

import cn from 'classnames';

import * as css from './BaseSwingThreadInput.css';

type Props = css.TextAreaVariants & TextareaHTMLAttributes<HTMLTextAreaElement>;

export const BaseSwingThreadInput = forwardRef<HTMLTextAreaElement, Props>(
    ({ className, noResize, noOverflow, ...props }, ref) => (
        <textarea ref={ref} className={cn(css.textArea({ noResize, noOverflow }), className)} {...props} />
    ),
);

BaseSwingThreadInput.displayName = 'BaseSwingThreadInput';
